import { render, staticRenderFns } from "./Statistics_Trips.vue?vue&type=template&id=9da188d6&scoped=true&"
import script from "./Statistics_Trips.vue?vue&type=script&lang=js&"
export * from "./Statistics_Trips.vue?vue&type=script&lang=js&"
import style0 from "./Statistics_Trips.vue?vue&type=style&index=0&id=9da188d6&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da188d6",
  null
  
)

export default component.exports